export { query as AppDangerSectionQuery } from './administrator/danger/AppDangerSection'
export { query as TransferAppSectionQuery } from './administrator/danger/TransferAppSection'
export { default as AppSettingsRouter } from './AppSettingsRouter'
export { query as AppSettingsFormQuery } from './general/AppSettingsForm'
